module.exports = __webpack_public_path__ + "static/media/home-service-slider-14.8166d0c6.jpg";